import ScrollToTop from './ScrollToTop'
import UserNavBar from '../../components/common/UserNavBar'
import UserFooter from '../../components/common/UserFooter'
import { Outlet } from 'react-router-dom'

const UserLayout = ({ children }) => {
  return (
    <>
      <ScrollToTop />
      <UserNavBar />
      {children || <Outlet />}
      <UserFooter />
    </>
  )
}

export default UserLayout